<template>
  <div class="about-product">
    <div class="about-product__container">
      <div>
        <h2 class="about-product__title">{{ messages.description }}</h2>
        <div class="about-product-controls">
          <div class="about-product-controls__item">
            {{ messages.aboutHoliday }}
          </div>
        </div>
        <div class="about-product-content" v-html="product.holiday.detailText"></div>
      </div>
      <div class="about-product-images">
        <DefImg v-for="(banner, i) in product.holiday.pictures" :key="i" :result="banner" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DefImg from '@components/Def/DefImg/DefImg.vue';

export default {
  name: 'AboutProduct',
  components: { DefImg },
  props: ['result'],
  computed: {
    ...mapState({
      product: ({ product }) => product.data.product,
      messages: ({ product }) => product.data.messages,
    }),
  },
};
</script>

<style lang="scss" scoped>
.about-product {
  background-color: #f6f6f6;
  margin-bottom: 64px;
  @include point-md {
    margin-bottom: 80px;
  }
  &__container {
    @extend %container;
    padding-top: 40px;
    padding-bottom: 40px;
    @include point-md {
      padding-top: 64px;
      padding-bottom: 64px;
    }
    @include point-lg {
      display: grid;
      grid-template-columns: 0.6fr 1fr;
      padding-top: 80px;
      padding-bottom: 80px;
      grid-column-gap: 111px;
    }
  }
  &__title {
    font-weight: 600;
    font-size: rem(16);
    line-height: 125%;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 24px;
    @include point-md {
      font-size: rem(18);
      line-height: 100%;
    }
  }
}
.about-product-controls {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  &__item {
    font-weight: 600;
    font-size: rem(12);
    line-height: 100%;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--color-dark-grey);
    transition: 0.2s linear color;
    /*cursor: pointer;*/
    &:not(:last-child) {
      margin-right: 32px;
    }
    &_active {
      color: var(--background-black);
      cursor: default;
    }
  }
}
.about-product-content {
  :deep {
    font-weight: 500;
    font-size: rem(16);
    line-height: 140%;
    color: var(--color-dark-grey);
    margin-bottom: 40px;
    @include point-lg {
      margin-bottom: 0;
    }
    p {
      margin-bottom: 32px;
    }
    a {
      text-decoration-line: underline;
      text-underline-position: under;
      transition: 0.2s linear color;
      cursor: pointer;
      color: var(--background-black);
      &:hover {
        color: var(--color-dark-grey);
      }
    }
  }
}
.about-product-images {
  display: grid;
  grid-template-columns: 1fr 0.55fr;
  grid-column-gap: 31px;
  @include point-md {
    grid-column-gap: 81px;
  }
  @include point-lg {
    grid-template-columns: 1fr 0.51fr;
    grid-column-gap: 83px;
  }
}
</style>
